// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------
import React, { useCallback, useState} from 'react';
import { LoadingOutlined } from '@ant-design/icons';

// -----------------------------------------------------------------------------
// Store
// -----------------------------------------------------------------------------
import { useGetRowsQuery } from '../../store/queries/rows';

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { RowCard } from '../../components/row-card';
import { MusicPlayerRow } from '../../components/music-player-row';

// -----------------------------------------------------------------------------
// Styles
// -----------------------------------------------------------------------------
import StyledHomePage from './styles';

// -----------------------------------------------------------------------------
// Offline data
// -----------------------------------------------------------------------------
import fallbackJsonData from '../../store/json/mixes9round.json'; 

// -------------------------------------------------------------------------------
// Functions
// -------------------------------------------------------------------------------

const mp3Queue = []; 
window.mixes = [];
window.musicdata = null;
window.currentlyplayingindex = -1;
window.firstLoad = true;
window.currentlyLoadedMixes = 0;


function addToQueue(mp3Url, id, index) {
  mp3Queue.push({ mp3Url, id, index });
}

function downloadNext() {
  if (mp3Queue.length > 0) {
    const { mp3Url, id, index } = mp3Queue[0];
    saveMP3(mp3Url, id, index); 
    // Remove the item from the queue after successful download
    mp3Queue.shift();
  }
}

// Open or create an IndexedDB database
const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open('resources', 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      db.createObjectStore('images', { keyPath: 'url' });
      db.createObjectStore('mp3', { keyPath: 'url' });
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = (error) => reject(error);
  });
};

// Save media data to IndexedDB
function cacheImage(url, mediaData) {
  openDB().then((db) => {
    const transaction = db.transaction(['images'], 'readwrite');
    const store = transaction.objectStore('images');
    store.put({ url, mediaData });
  });
}

// Save media data to IndexedDB
function cacheMedia(url, mediaData) {
  openDB().then((db) => {
    const transaction = db.transaction(['mp3'], 'readwrite');
    const store = transaction.objectStore('mp3');
    store.put({ url, mediaData });
  });
}


// Retrieve image data from IndexedDB
function getCachedImage(url) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(['images'], 'readonly');
      const store = transaction.objectStore('images');
      const request = store.get(url);

      request.onsuccess = () => {
        const result = request.result;
        resolve(result ? result.mediaData : null);
      };

      request.onerror = (error) => reject(error);
    });
  });
}

function getCachedMp3(url) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(['mp3'], 'readonly');
      const store = transaction.objectStore('mp3');
      const request = store.get(url);

      request.onsuccess = () => {
        const result = request.result;
        resolve(result ? result.mediaData : null);
      };

      request.onerror = (error) => reject(error);
    });
  });
}

function isKeyCached(url) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(['mp3'], 'readonly');
      const store = transaction.objectStore('mp3');
      const request = store.count(url);

      request.onsuccess = () => {
        const count = request.result;
        resolve(count > 0); // Resolve true if the key exists, false otherwise
      };

      request.onerror = (error) => reject(error);
    });
  });
}

// Fetch and cache image
function fetchAndCacheImage(url) {
  getCachedImage(url).then((cachedImageData) => {
    if (!cachedImageData) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onload = () => {
            const imageData = reader.result;
            cacheImage(url,  imageData);
          };
          reader.readAsDataURL(blob);
        })
        .catch((error) => console.error('Error fetching image:', error));
    }
  });
}
 

function saveMP3(mp3Url, id, index) {
  isKeyCached(mp3Url).then((isCached) => {
      if (isCached) {
        downloadNext();
        assignMP3Data(id);
      } else {
        fetch(mp3Url)
          .then((response) => response.blob())
          .then((blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              const fileData = reader.result;
              cacheMedia(mp3Url, fileData);
              //const blobUrl=URL.createObjectURL(blob);
              assignMP3Url(id);
              downloadNext();
              assignMP3Data(id);
              
            };
            reader.readAsDataURL(blob);   
          })
          .catch((error) => {
            console.error('Error fetching MP3:', error);
            downloadNext();
          });
      }
  });
}

function assignMP3Url(index) {
  for(let i = 0; i < window.mixes.length; i++) {
    if(window.mixes[i].id === index) {
     // window.mixes[i].isCached = 1;
      //window.mixes[i].blobUrl = blobUrl;
      let container=document.getElementById('mixcontainer_' + i);
      container.style.display = "block"; 
     }
  }
}

function assignMP3Data(index) {
  for(let i = 0; i < window.mixes.length; i++) {
    if(window.mixes[i].id === index) {
      window.mixes[i].isCached = 2;
      window.currentlyLoadedMixes++;
      let container=document.getElementById('mixcontainer_' + i);
      container.style.display = "block"; 
     }
  }
}

function deepCopyObject(obj) {
  if (typeof obj !== 'object' || obj === null) {
      return obj; // Return non-object elements as they are
  }

  // Create a new object to hold the deep copy
  const newObj = {};

  // Iterate through the original object's properties
  for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
          // Recursively deep copy nested objects
          newObj[key] = deepCopyObject(obj[key]);
      }
  }

  return newObj;
}

function assignMixes(mixes) {
  if(window.mixes.length === 0) {
    window.mixes = [];
    for(let i = 0; i < mixes.length; i++) {
      window.mixes.push(deepCopyObject(mixes[i]));
    }
    for(let i = 0; i < mixes.length; i++) {
      
      window.mixes[i].genre_name = "9Round";
      window.mixes[i].isCached = 0;
      window.mixes[i].blobUrl = null;
      window.mixes[i].Tracklists = mixes[i].Tracklists;
      window.mixes[i].Tags = mixes[i].Tags;
        fetchAndCacheImage(window.mixes[i].background_image);
        getCachedImage(window.mixes[i].background_image).then((cachedImageData) => {
          if (cachedImageData) {
            window.mixes[i].background_image = cachedImageData;
          }
        });
  
        addToQueue(window.mixes[i].default_url, window.mixes[i].id, i);
    }
    downloadNext();
    downloadNext();
  }
}



// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const HomePage = () => {
  const [track, setTrack] = useState(null);
  const [firstLoad, setFirstLoad] = useState(true);
  let { data, isLoading } = useGetRowsQuery();
   
  if(data === undefined && !isLoading) {
    data = fallbackJsonData;
    assignMixes(data.mixes);
  }
  if(!isLoading) {
    assignMixes(data.mixes);
  }
  
  const setLocalTrack = useCallback((data, first) => {
    setTrack(data);
    setFirstLoad(first);
  }, []);



  return (
    <StyledHomePage>
      <div className="fr-home-page">
        {isLoading && (
          <div className="fr-home-page__loading-container">
            <LoadingOutlined spin />
          </div>
        )}
        {!isLoading && data  && (
          <div className="fr-home-page__cards">
            {window.mixes.map((item, index) => (
               <div id={`mixcontainer_${index}`} style={{ display: 'none', width: 'calc(50% - 16px)', height:'260px' }}>
              <RowCard
                key={`rows-item-${index}`}
                rowData={item}
                index={index}
                length={window.mixes.length}
                setTrack={setLocalTrack}
                getCachedMp3={getCachedMp3}
              />
              </div>
            ))}
          </div>
        )}
        <div className="fr-home-page__player">
          <MusicPlayerRow track={track}  firstLoad={firstLoad} />
        </div>
      </div>
    </StyledHomePage>
  );
};

export default HomePage;
